import React, {useState} from 'react';
import StarIcon from '@material-ui/icons/Star';
import StarHalfIcon from '@material-ui/icons/StarHalf';
import {useDispatch} from 'react-redux';
import './Product.css';
import {addToBasket} from '../../../features/album/albumSlice';
import {useHistory} from 'react-router-dom';
import {store} from '../../../app/store';

function Product({id, title, price, image, tracks, reviews, countInStock}) {
  const history = useHistory();
  const [qty, setQty] = useState(1);
  const dispatch = useDispatch();
  const addMusicToBasket = () => {
    dispatch(
      addToBasket({
        id,
        title,
        price,
        image,
        tracks,
        reviews,
        countInStock,
        qty,
      })
    );
    localStorage.setItem('cart', JSON.stringify(store.getState().album.basket));

    history.push('/cart');
  };

  return (
    <div className="product main">
      <div className="product__grid container">
        <article className="product__left">
          <div className="product__left__container">
            <img src={image} alt={title} />
          </div>
        </article>
        <article className="product__right">
          <h1>{title}</h1>

          <h4>{price} RWF</h4>
          <article className="rating">
            {reviews > 0 ? (
              <>
                <StarIcon className="rating__star" />
                <StarIcon className="rating__star" />
                <StarIcon className="rating__star" />
                <StarIcon className="rating__star" />
                <StarHalfIcon className="rating__star" />
                <small style={{fontSize: '12px', paddingLeft: '5px'}}>
                  Reviews
                </small>
              </>
            ) : (
              ''
            )}
          </article>
          <div className="addtochart__container">
            <div className="addtochart__row">
              <small> {countInStock > 0 ? 'In Stock' : 'Out of stock'}</small>
              <select
                name="quantity"
                id=""
                value={qty}
                onChange={(e) => setQty(e.target.value)}
              >
                {[...Array(countInStock).keys()].map((val) => (
                  <option key={val + 1} value={val + 1}>
                    {val + 1}
                  </option>
                ))}
              </select>
            </div>
            <button className="btn" onClick={addMusicToBasket}>
              Add To Cart
            </button>
          </div>
          <h3>Details</h3>
          <br />
          <p>Tracking list</p>
          <b>Disc</b>
          <ol>
            {tracks?.map((element, index) => (
              <li key={index}>{element}</li>
            ))}
          </ol>
          <hr />
        </article>
      </div>
    </div>
  );
}

export default Product;
